import * as types from './mutation-types'
import { allSettled } from '@/core/helpers/promise.helpers'
import axios from 'axios'

/**
 *  Boot user types
 *
 * @param dispatch
 * @param rootGetters
 *
 * @returns {Promise<any>}
 */
export const boot = ({ dispatch, rootGetters }) => {
  const boot = rootGetters['auth/entitlements'].getAnyPassed({
    'fetchUserTypes': { user_type: 'read' }
  }).map(action => dispatch(action)).map(allSettled)

  return Promise.all(boot)
}

/**
 * Fetch all user types
 *
 * @param commit
 */
export const fetchUserTypes = ({ commit, rootGetters }) => {
  return new Promise((resolve, reject) => {
    rootGetters['auth/entitlements'].can({ user_type: 'read' }, { throwError: true })

    axios.get('/api/v1/user_types/')
      .then((resp) => {
        commit(types.FETCH_USER_TYPES, resp.data.items)
        resolve(resp)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * Reset stored data
 *
 * @param commit
 */
export const clear = ({ commit }) => {
  commit(types.CLEAR)
}

export default {
  boot,
  clear,
  fetchUserTypes
}
